var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VButton',_vm._g({staticClass:"back-button transparent",class:{ small: _vm.small !== false }},_vm.$listeners),[_c('IconArrowRight',{class:['back-arrow', { 'with-text': _vm.showLabel }]}),(_vm.showLabel)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }